<template>
  <section class="know-that">
    <h3 class="know-that__title">
      {{ $t('multibilet.knowThat.title') }}
    </h3>

    <div class="know-that__content">
      <div class="know-that__description">
        <p class="know-that__data">
          {{ $t('multibilet.knowThat.data') }}
        </p>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.know-that {
  position: relative;
  z-index: -1;
  display: grid;
  gap: 2.4rem;
  margin-top: -2.4rem;
  padding: 6.4rem 0.8rem 1.6rem;
  background-color: $gray-200;

  &__title {
    @include h8;
    color: $text-400;
    text-align: center;
  }

  &__content {
    display: grid;
    grid-auto-flow: column;
    gap: 1.6rem;
    padding: 2.4rem 1.8rem;
    background-color: white;
    border-radius: 1.6rem;
  }

  &__description {
    display: grid;
    align-content: flex-start;
    gap: 1.6rem;
  }

  &__data {
    @include body-2-medium;
    color: $text-400;
  }
}

@include atXS {
  .know-that {
    padding: 6.4rem 4rem 4rem;

    &__title {
      @include h7;
    }

    &__content {
      padding: 0;
      background-color: transparent;
    }

    &__description {
      gap: 3.2rem;
      padding: 4rem 3.2rem 3.2rem;
      background-color: white;
      border-radius: 2.4rem;
    }

    &__data {
      @include h10;
    }
  }
}

@include atM {
  .know-that {
    gap: 4rem;
    padding: 10.4rem 6rem 6.4rem;

    &__content {
      max-width: 120rem;
      margin: 0 auto;
    }

    &__title {
      @include h5;
    }

    &__description {
      gap: 2.4rem;
      padding: 4rem 5.6rem 4rem 4rem;
    }

    &__data {
      @include h9;
    }
  }
}
</style>
